import { render, staticRenderFns } from "./PeerGroupList.vue?vue&type=template&id=dcdcc084&scoped=true&"
import script from "./PeerGroupList.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./PeerGroupList.vue?vue&type=style&index=0&id=dcdcc084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdcc084",
  null
  
)

export default component.exports